import reducer from "./reducer";
export { default as TypesOfPublicationChannels } from "./components/index";
export { default as typesOfPublicationChannelsReducerName } from "./constants";
export default reducer;
